import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Dashboard.module.css";

// Card shell. When `data` is null (that section failed on the server), shows
// "Couldn't load" with a retry instead of `children`.
const DashboardCard = ({
  title,
  action,
  data,
  onRetry,
  isRetrying,
  children,
}) => (
  <div className={styles.card}>
    <div className={styles.cardHeader}>
      <h6 className={styles.cardTitle}>{title}</h6>
      {data != null && action}
    </div>
    <div className={styles.cardBody}>
      {data == null ? (
        <div className={styles.unavailable}>
          <span>
            <i className="bi bi-exclamation-circle me-1"></i>
            Couldn't load this section.
          </span>
          <button
            type="button"
            className={cx(ui.linkButton)}
            onClick={onRetry}
            disabled={isRetrying}
          >
            {isRetrying ? "Retrying…" : "Retry"}
          </button>
        </div>
      ) : (
        children(data)
      )}
    </div>
  </div>
);

export default DashboardCard;
